import Image from 'next/legacy/image';

const Logo = () => (
  <Image src="/icons/logo/colored-logo.svg" width={149} height={42} alt="Hydrolix logo" />
);

export default Logo;
